/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.backlog.rpc.BookmarkRpc
 */

export const addBookmarkRpc = {
  serviceName: 'com.hubspot.academy.learning.backlog.rpc.BookmarkRpc',
  rpcName: 'addBookmark',
  auth: 'app',
  fingerprint: 'bDVRTerG0ZlkUzOEtJ-TvW5TH52RemiM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeBookmarkRpc = {
  serviceName: 'com.hubspot.academy.learning.backlog.rpc.BookmarkRpc',
  rpcName: 'removeBookmark',
  auth: 'app',
  fingerprint: 'Vtcvg54zF8tkUzOEtJ-TvW5TH52RemiM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBookmarksRpc = {
  serviceName: 'com.hubspot.academy.learning.backlog.rpc.BookmarkRpc',
  rpcName: 'getBookmarks',
  auth: 'app',
  fingerprint: 'vTIRzZsfpn0e4QEqJzCvW25TH52RemiM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};